<div class="transaction-details-container">
  <div class="header">
    <span>Enter your domain to discover all SSL certificates and subdomains associated with it via the Certificate Transparency logs.</span>
    <div class="actions">
      <button type="button" class="filter-button secondary-button" (click)="openDownloadSampleModal()">
        <i class="fa-solid fa-download" style="margin-right: 8px;"></i>
        <span>Download Sample</span>
      </button>
      <button type="button" class="filter-button secondary-button" [disabled]="isUploading" (click)="triggerUpload()">
        <i class="fa-solid fa-spinner fa-spin" style="margin-right: 8px;" *ngIf="isUploading"></i>
        <i class="fa-solid fa-upload" style="margin-right: 8px;" *ngIf="!isUploading"></i>
        <span>{{ isUploading ? 'Uploading ' + uploadProcessed + '/' + uploadTotal : 'Upload Domains' }}</span>
      </button>
      <input
        #fileInput
        type="file"
        accept=".csv,.xlsx,.xls"
        style="display: none;"
        (change)="onFileSelected($event)"
      />
      <button type="button" class="filter-button secondary-button" (click)="goBack()">
        <i class="fa-solid fa-arrow-left" style="margin-right: 8px;"></i>
        <span>Back to Domains</span>
      </button>
    </div>
  </div>

  <div class="popup-overlay" *ngIf="showFormatModal" (click)="closeFormatModal()">
    <div class="popup-card format-modal-card" (click)="$event.stopPropagation()">
      <div class="popup-header">
        <div class="popup-title">
          <i class="fa-solid fa-file-arrow-down popup-title-icon"></i>
          <span>Download Sample File</span>
        </div>
        <button class="popup-close" (click)="closeFormatModal()">
          <i class="fa-solid fa-xmark"></i>
        </button>
      </div>
      <div class="popup-body format-modal-body">
        <p>Choose a file format for the sample domains template.</p>
        <div class="format-modal-actions">
          <button type="button" class="filter-button secondary-button" (click)="downloadSample('csv')">
            <i class="fa-solid fa-file-csv" style="margin-right: 8px;"></i>
            <span>CSV</span>
          </button>
          <button type="button" class="filter-button submit-button" (click)="downloadSample('excel')">
            <i class="fa-solid fa-file-excel" style="margin-right: 8px;"></i>
            <span>Excel</span>
          </button>
        </div>
      </div>
    </div>
  </div>

  <div class="form-container">
    <form (ngSubmit)="submitDomain()" class="domain-form">
      <label for="domain-input" class="form-label">Domain Name</label>
      <div class="domain-input-wrapper">
        <i class="fa-solid fa-globe input-icon"></i>
        <input
          id="domain-input"
          type="text"
          name="domain"
          [(ngModel)]="domain"
          placeholder="e.g. aisslo.com"
          class="domain-input"
          [disabled]="isSubmitting"
          autocomplete="off"
        />
      </div>
      <p class="form-hint">We will scan Certificate Transparency logs to find all known subdomains and SSL certificates for this domain.</p>
      <div class="form-actions">
        <button type="submit" class="filter-button submit-button" [disabled]="isSubmitting">
          <i class="fa-solid fa-magnifying-glass" style="margin-right: 8px;" *ngIf="!isSubmitting"></i>
          <i class="fa-solid fa-spinner fa-spin" style="margin-right: 8px;" *ngIf="isSubmitting"></i>
          {{ isSubmitting ? 'Searching...' : 'Search Domain' }}
        </button>
      </div>
    </form>
  </div>
</div>
